
import { Vue } from 'vue-class-component'
import { BigItem } from '../data-model'
import { Prop } from 'vue-property-decorator'

export default class BigSVG extends Vue {
    @Prop({ required: true }) mdata!: BigItem
}
